import styled from "styled-components";

export const Container = styled.div`
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.grey3};
  border-radius: 8.17112px;
  min-height: 85px;
  cursor: pointer;
`;
